<template>
  <div class="ereport">
    <div class="point">
      <div>督查点位：</div>
      <div class="name">{{ detail.point_name }}</div>
    </div>
    <div class="content">
      <div>考察内容：</div>
      <div>{{ detail.cate_name }}</div>
    </div>
    <div class="h"></div>
    <div class="content">
      <div>地址：</div>
      <div>{{ detail.address }}</div>
    </div>
    <div class="imgcon">
      <div>
        <span class="red">*</span>上传照片
        <span class="tips">（现场拍照、最多3张）</span>
      </div>
      <div>
        <upload :maxCount="3" v-model="detail.img" />
      </div>
    </div>
    <div class="describe">
      <div class="title">事件描述</div>
      <div>
        <textarea
          placeholder="请简单描述..."
          v-model="detail.content"
        ></textarea>
      </div>
    </div>
    <div class="btn" @click="submit">确认修改</div>
  </div>
</template>
<script>
import upload from "@/components/Upload";
import { editOrder, getMyEventDetail } from "../api";
export default {
  components: {
    upload,
  },
  data() {
    return {
      detail: {},
    };
  },
  created() {
    const { id } = this.$route.query;
    id &&
      getMyEventDetail({ id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data;
        }
      });
  },
  methods: {
    submit() {
      const { id, address, img, content } = this.detail;
      editOrder({ id, address, img, content }).then((res) => {
        if (res.code == 0) {
          this.$toast.success("修改成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1200);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.ereport {
  color: #333;
  font-size: 15px;
  text-align: left;
  background: #fff;
  padding: 0 0 10px;
  > div {
    width: calc(100% - 30px);
    margin: auto;
    .red {
      color: #ff0000;
    }
    .tips {
      color: #9c9c9c;
      font-size: 14px;
    }
  }
  .point {
    border-bottom: 1px solid #d7d7d7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 11px;
    padding: 11px 0;
  }
  .content {
    > div:first-child {
      line-height: 20px;
      margin-bottom: 10px;
    }
    > div:last-child {
      padding: 11px;
      background: rgba(244, 246, 248, 1);
      border-radius: 6px;
      margin-bottom: 10px;
    }
  }
  .h {
    width: 100%;
    height: 10px;
    background: rgba(243, 244, 246, 1);
    margin-bottom: 10px;
  }
  .imgcon {
    border-bottom: 1px solid #d7d7d7;
    margin-bottom: 11px;
    > div:last-child {
      margin: 14px 0 10px 0;
    }
  }
  .describe {
    margin-bottom: 10px;
    .title {
      margin: 5px auto;
    }
    textarea {
      width: 100%;
      height: 2.8rem;
      border: 0.02rem solid rgba(225, 225, 225, 1);
      border-radius: 6px;
      padding: 10px;
      background: rgba(244, 246, 248, 1);
    }
    textarea::-webkit-input-placeholder {
      color: #969799;
    }
  }
  .btn {
    height: 1rem;
    width: calc(100% - 30px);
    line-height: 1rem;
    background: rgba(32, 106, 255, 1);
    color: #fff;
    text-align: center;
    border-radius: 6px;
  }
}
</style>
